// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Banner.module.css */
.Banner_banner__7EnNA {
    position: relative;
    width: 100%;
    height: auto;
    overflow: hidden;
    margin-top: 100px;
}

.Banner_media__1omAx {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
}

.Banner_sloganContainer__Tjr9u {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 1200px;
    text-align: center;
    padding: 20px;
    z-index: 2;
}

.Banner_slogan__NJp1E {
    color: var(--color-text-white);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    margin: 0;
    padding: 0;
    line-height: 1.2;
}

.Banner_subSlogan__uvGhw {
    color: var(--color-text-white);
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    margin-top: 15px;
    line-height: 1.2;
}

/* Tamanhos maiores para desktop */
.Banner_banner__7EnNA h1 {
    font-size: 4.5rem;
    /* Aumentado de 3.5rem */
    font-weight: 700;
}

.Banner_banner__7EnNA h2 {
    font-size: 3.2rem;
    /* Aumentado de 2.5rem */
    font-weight: 600;
}

.Banner_banner__7EnNA h3 {
    font-size: 2.4rem;
    /* Aumentado de 1.8rem */
    font-weight: 500;
}

/* Telas grandes */
@media (min-width: 1440px) {
    .Banner_banner__7EnNA h1 {
        font-size: 5.5rem;
    }

    .Banner_banner__7EnNA h2 {
        font-size: 4rem;
    }

    .Banner_banner__7EnNA h3 {
        font-size: 3rem;
    }

    .Banner_media__1omAx {
        height: 50vh;
    }
}

/* Tablets e telas médias */
@media (max-width: 768px) {
    .Banner_media__1omAx {
        height: 40vh;
        object-position: center;
    }

    .Banner_banner__7EnNA h1 {
        font-size: 2.8rem;
    }

    .Banner_banner__7EnNA h2 {
        font-size: 2rem;
    }

    .Banner_banner__7EnNA h3 {
        font-size: 1.5rem;
    }

    .Banner_sloganContainer__Tjr9u {
        width: 85%;
        padding: 15px;
    }
}

/* Smartphones */
@media (max-width: 480px) {
    .Banner_media__1omAx {
        height: 30vh;
    }

    .Banner_banner__7EnNA h1 {
        font-size: 2rem;
    }

    .Banner_banner__7EnNA h2 {
        font-size: 1.5rem;
    }

    .Banner_banner__7EnNA h3 {
        font-size: 1.2rem;
    }

    .Banner_sloganContainer__Tjr9u {
        width: 90%;
        padding: 10px;
    }

    .Banner_subSlogan__uvGhw {
        margin-top: 5px;
    }
}

/* Smartphones muito pequenos */
@media (max-width: 320px) {
    .Banner_media__1omAx {
        height: 25vh;
    }

    .Banner_banner__7EnNA h1 {
        font-size: 1.8rem;
    }

    .Banner_banner__7EnNA h2 {
        font-size: 1.3rem;
    }

    .Banner_banner__7EnNA h3 {
        font-size: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Site/Banner/Banner.module.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,+BAA+B;AAC/B;IACI;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Banner.module.css */\r\n.banner {\r\n    position: relative;\r\n    width: 100%;\r\n    height: auto;\r\n    overflow: hidden;\r\n    margin-top: 100px;\r\n}\r\n\r\n.media {\r\n    width: 100%;\r\n    height: auto;\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n\r\n.sloganContainer {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 90%;\r\n    max-width: 1200px;\r\n    text-align: center;\r\n    padding: 20px;\r\n    z-index: 2;\r\n}\r\n\r\n.slogan {\r\n    color: var(--color-text-white);\r\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n    margin: 0;\r\n    padding: 0;\r\n    line-height: 1.2;\r\n}\r\n\r\n.subSlogan {\r\n    color: var(--color-text-white);\r\n    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);\r\n    margin-top: 15px;\r\n    line-height: 1.2;\r\n}\r\n\r\n/* Tamanhos maiores para desktop */\r\n.banner h1 {\r\n    font-size: 4.5rem;\r\n    /* Aumentado de 3.5rem */\r\n    font-weight: 700;\r\n}\r\n\r\n.banner h2 {\r\n    font-size: 3.2rem;\r\n    /* Aumentado de 2.5rem */\r\n    font-weight: 600;\r\n}\r\n\r\n.banner h3 {\r\n    font-size: 2.4rem;\r\n    /* Aumentado de 1.8rem */\r\n    font-weight: 500;\r\n}\r\n\r\n/* Telas grandes */\r\n@media (min-width: 1440px) {\r\n    .banner h1 {\r\n        font-size: 5.5rem;\r\n    }\r\n\r\n    .banner h2 {\r\n        font-size: 4rem;\r\n    }\r\n\r\n    .banner h3 {\r\n        font-size: 3rem;\r\n    }\r\n\r\n    .media {\r\n        height: 50vh;\r\n    }\r\n}\r\n\r\n/* Tablets e telas médias */\r\n@media (max-width: 768px) {\r\n    .media {\r\n        height: 40vh;\r\n        object-position: center;\r\n    }\r\n\r\n    .banner h1 {\r\n        font-size: 2.8rem;\r\n    }\r\n\r\n    .banner h2 {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .banner h3 {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .sloganContainer {\r\n        width: 85%;\r\n        padding: 15px;\r\n    }\r\n}\r\n\r\n/* Smartphones */\r\n@media (max-width: 480px) {\r\n    .media {\r\n        height: 30vh;\r\n    }\r\n\r\n    .banner h1 {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .banner h2 {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .banner h3 {\r\n        font-size: 1.2rem;\r\n    }\r\n\r\n    .sloganContainer {\r\n        width: 90%;\r\n        padding: 10px;\r\n    }\r\n\r\n    .subSlogan {\r\n        margin-top: 5px;\r\n    }\r\n}\r\n\r\n/* Smartphones muito pequenos */\r\n@media (max-width: 320px) {\r\n    .media {\r\n        height: 25vh;\r\n    }\r\n\r\n    .banner h1 {\r\n        font-size: 1.8rem;\r\n    }\r\n\r\n    .banner h2 {\r\n        font-size: 1.3rem;\r\n    }\r\n\r\n    .banner h3 {\r\n        font-size: 1rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `Banner_banner__7EnNA`,
	"media": `Banner_media__1omAx`,
	"sloganContainer": `Banner_sloganContainer__Tjr9u`,
	"slogan": `Banner_slogan__NJp1E`,
	"subSlogan": `Banner_subSlogan__uvGhw`
};
export default ___CSS_LOADER_EXPORT___;
